import type { ReactNode } from 'react';

type CouponRowHeaderSrowsProps = {
  rowNumber: number;
};

/**
 * Renders a coupon row header with text content 'Rad couponIndex'.
 *
 * @param root0 props for the component
 * @param root0.rowNumber the row number to display
 * @returns The rendered header component
 */
export default function CouponRowHeaderSrows({ rowNumber }: CouponRowHeaderSrowsProps): ReactNode {
  return (
    <div className="grid items-center justify-start">
      <span>{`Rad ${rowNumber}`}</span>
    </div>
  );
}
